import { redirectToPayments } from '../utils';

function _initializeStoreCallMutations(commit, existingStore) {
    if (existingStore && existingStore.permitValidated) {
        commit('setPermitValidated', true);
        commit('setPermitNumber', existingStore.permitNumber);
        commit('setPermitYear', existingStore.permitYear);
        commit('setFacilityUsages', existingStore.facilityUsages);
        commit('setEmail', existingStore.email);
        commit('setZeroFacilityUsagesReport', existingStore.zeroFacilityUsagesReport);
        commit('setIsZeroFacilityUsagesReportSubmission', existingStore.isZeroFacilityUsagesReportSubmission);
    }
    else {
        commit('setFacilityUsages', []);
        commit('setEmail', null);
        commit('setZeroFacilityUsagesReport', false);
        commit('setIsZeroFacilityUsagesReportSubmission', false);
    }

    commit('setPersistentStorageChecked', true);
    commit('setPerformingInitialLoad', false);
}

function initializeStore({ commit, state }, { permitNumber, permitYear }) {

    if (!state.permitValidated) {
        return;
    }

    //if (window.localStorage) {
    //    let existingStore = window.localStorage.getItem(`__prksusg__${permitNumber}__${permitYear}__`);
    //    existingStore = existingStore ? JSON.parse(existingStore) : null;

    //    if (existingStore && Date.now() - new Date(existingStore.createdTimestamp) > 20 * 60000) {
    //        existingStore = null;
    //    }

    //    _initializeStoreCallMutations(commit, existingStore);

    //    return;
    //}

    commit('setShouldAutosave', false);
    commit('setPendingAsyncRequest', true);

    return $.post(`${state.baseUrl}/home/initializeStore`, {
        __RequestVerificationToken: state.requestVerificationToken,
        permitNumber,
        permitYear
    }).then(response => {
        if (response) {
            const { email, facilityUsages, lasNumber, permitValidated, permitYear } = response;
            _initializeStoreCallMutations(commit, {
                email: email,
                facilityUsages: facilityUsages,
                permitNumber: lasNumber,
                permitValidated: permitValidated,
                permitYear: permitYear
            });
        }
        else {
            _initializeStoreCallMutations(commit, null);
        }

        commit('setShouldAutosave', true);
        commit('setPendingAsyncRequest', false);
    }, response => {
        console.log('error response callback', response);
    });
}

function validateAndSetPermitNumber({ commit, state }, { permitNumber, permitYear }) {
    commit('setPendingAsyncRequest', true);

    return $.post(`${state.baseUrl}/home/checkPermitNumber/`, {
        permitNumber,
        permitYear,
        __RequestVerificationToken: state.requestVerificationToken
    }).then(response => {
        if (response.result) {
            const { dbaLastName, dbaFirstName, ownerLastName, ownerFirstName, ownerEmail, permitYear } = response;
            commit('setPersistentStorageChecked', false);
            commit('setPermitValidated', true);
            commit('setPermitNumberServerValidationError', false);
            commit('setPermitNumberServerValidationErrorMessage', null);
            commit('setPermitNumber', permitNumber);
            commit('setPermitYear', permitYear);
            commit('setBusinessName', `${dbaLastName || ''}${dbaFirstName || ''}`);
            commit('setContactPerson', `${ownerLastName || ''}${ownerFirstName ? `, ${ownerFirstName}` : ''}`);
        }
        else {
            commit('setPermitValidated', false);
            commit('setPermitNumberServerValidationError', true);
            commit('setPermitNumberServerValidationErrorMessage', response.message);
        }

        commit('setPendingAsyncRequest', false);
    }, response => {
        console.log('error response callback', response);
    });
}

function submitUsageReport({ commit, state }) {
    commit('setPendingAsyncRequest', true);

    return $.post(`${state.baseUrl}/home/submit/`, {
        BusinessName: state.businessName,
        ContactPerson: state.contactPerson,
        Email: state.email,
        LASNumber: state.permitNumber,
        PermitYear: state.permitYear,
        ZeroFacilityUsagesReport: state.zeroFacilityUsagesReport,
        FacilityUsages: !state.zeroFacilityUsagesReport ? state.facilityUsages.map(u => {
            return {
                FacilityId: u.facilityId,
                ActivityId: u.activityId,
                ClientDays: u.clientDays
            };
        }) : [],
        __RequestVerificationToken: state.requestVerificationToken
    }).then(response => {
        if (!response.result) {
            return response;
        }

        if (!state.zeroFacilityUsagesReport && !response.zeroFacilityUsagesReport) {
            redirectToPayments(response);
        }
        else {
            commit('setZeroFacilityUsagesReport', true);
            commit('setIsZeroFacilityUsagesReportSubmission', true);
            commit('setPendingAsyncRequest', false);
        }

        return response;
    }, response => {
        console.log('error response callback', response);
    });
}

function addFacilityUsage({ commit }, facilityUsage) {
    commit('addFacilityUsage', facilityUsage);
}

function removeFacilityUsage({ commit }, index) {
    commit('removeFacilityUsage', index);
}

function updateFacilityUsage({ commit, getters }, facilityUsage) {
    commit('updateFacilityUsage', {
        facilityUsage,
        index: getters.indexOfFacilityUsage(facilityUsage)
    });
}

function getPermitYears({ state, commit }) {
    commit('setPermitYearsLoading', true);

    return $.post(`${state.baseUrl}/home/permitYears`, {
        __RequestVerificationToken: state.requestVerificationToken
    }).then(response => {
        commit('setPermitYears', response);
        commit('setPermitYearsLoading', false);
    }, response => {
        console.log('error response callback', response);
    });
}

function getActivities({ state, commit }) {
    commit('setActivitiesLoading', true);

    return $.post(`${state.baseUrl}/home/activities`, {
        __RequestVerificationToken: state.requestVerificationToken
    }).then(response => {
        commit('setActivities', response);
        commit('setActivitiesLoading', false);
    }, response => {
        console.log('error response callback', response);
    });
}

function getAreas({ state, commit }) {
    commit('setAreasLoading', true);

    return $.post(`${state.baseUrl}/home/areas`, {
        __RequestVerificationToken: state.requestVerificationToken
    }).then(response => {
        commit('setAreas', response);
        commit('setAreasLoading', false);
    }, response => {
        console.log('error response callback', response);
    });
}

function getFacilities({ state, commit }, areaId) {
    commit('setFacilitiesLoading', true);

    return $.post(`${state.baseUrl}/home/facilities`, {
        areaId,
        __RequestVerificationToken: state.requestVerificationToken
    }).then(response => {
        commit('setFacilities', response);
        commit('setFacilitiesLoading', false);
    }, response => {
        console.log('error response callback', response);
    });
}

function reloadFacilitiesFields({ commit }) {
    commit('setFacilities', null);
    commit('setFacilitiesLoading', false);
}

function reloadActivitiesFields({ commit }) {
    commit('setActivities', null);
    commit('setActivitiesLoading', false);
}

function setEmail({ commit }, email) {
    commit('setEmail', email);
}

function setZeroFacilityUsagesReport({ commit }, zeroFacilityUsagesReport) {
    commit('setZeroFacilityUsagesReport', zeroFacilityUsagesReport);
}

function setPerformingInitialLoad({ commit }, performingInitialLoad) {
    commit('setPerformingInitialLoad', false);
}

export default {
    initializeStore,
    validateAndSetPermitNumber,
    submitUsageReport,
    addFacilityUsage,
    removeFacilityUsage,
    updateFacilityUsage,
    getPermitYears,
    getActivities,
    getAreas,
    getFacilities,
    reloadFacilitiesFields,
    reloadActivitiesFields,
    setEmail,
    setZeroFacilityUsagesReport,
    setPerformingInitialLoad
};